// App.js
import { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import Recipes from './pages/Recipes/Recipes';
import Vendors from './pages/Vendors';
import BillingAndOrders from './pages/BillingAndOrders/BillingAndOrders';
import Reports from './pages/Reports/Reports';
import BottomNav from './components/BottomNav';
import KitchenOrders from './pages/KitchenOrders';
import Login from './pages/login';
import { isAuthenticated, removeAuthToken } from './auth';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const [activeTab, setActiveTab] = useState('Dashboard');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currency, setCurrency] = useState({
    symbol: '₹',
    code: 'INR',
    locale: 'en-IN'
  });
  const navigate = useNavigate();

  // Check authentication status
  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);
      try {
        const authStatus = isAuthenticated();
        setIsLoggedIn(authStatus);
        
        if (!authStatus && window.location.pathname !== '/login') {
          navigate('/login', { replace: true });
        } else if (authStatus && window.location.pathname === '/login') {
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Authentication check failed:', error);
        navigate('/login');
      } finally {
        setIsLoading(false);
      }
    };
    
    checkAuth();
  }, [navigate]);

  const handleLogin = () => {
    setIsLoggedIn(true);
    navigate('/');
  };

  const handleLogout = () => {
    removeAuthToken();
    setIsLoggedIn(false);
    navigate('/login', { replace: true });
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'Dashboard': return <Dashboard currency={currency} setCurrency={setCurrency} />;
      case 'Inventory': return <Inventory currency={currency} setCurrency={setCurrency} />;
      case 'Recipes': return <Recipes currency={currency} setCurrency={setCurrency} />;
      case 'Vendors': return <Vendors currency={currency} setCurrency={setCurrency} />;
      case 'BillingAndOrders': return <BillingAndOrders currency={currency} setCurrency={setCurrency} />;
      case 'Kitchen': return <KitchenOrders currency={currency} setCurrency={setCurrency} />;
      case 'Reports': return <Reports currency={currency} setCurrency={setCurrency} />;
      default: return <Dashboard currency={currency} setCurrency={setCurrency} />;
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex flex-col">
      <Routes>
        <Route 
          path="/login" 
          element={
            isLoggedIn ? (
              <Navigate to="/" replace />
            ) : (
              <Login onLogin={handleLogin} />
            )
          } 
        />
        
        <Route 
          path="/" 
          element={
            isLoggedIn ? (
              <>
                <main className="flex-1 p-4 pb-20 max-w-6xl w-full mx-auto">
                  {renderContent()}
                </main>
                <BottomNav 
                  activeTab={activeTab} 
                  setActiveTab={setActiveTab} 
                  onLogout={handleLogout}
                />
              </>
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
      </Routes>
    </div>
  );
}

export default App;